<script>
	import { getContext } from 'svelte'
	import { percent } from '../utils'

	const { xScale } = getContext('LayerCake')

	export let color = '#000'
	export let x
	export let y1
	export let y2
	export let label
</script>

<div class="mark-group">
	<div
		class="mark-line"
		style:left={percent($xScale(x))}
		style:top={percent(y1)}
		style:height={percent(y2 - y1)}
		style:background={color}>
	</div>
	<div
		class="mark-circle"
		style:left={percent($xScale(x))}
		style:top={percent(y1)}
		style:background={color}>
	</div>
	<div
		class="mark-label"
		style:left={percent($xScale(x))}
		style:top={percent(y1)}
		style:color>
		{@html label}
	</div>
</div>

<style lang="scss">
	.mark-group {
		user-select: none;
	}
	.mark-line {
		transform: translateX(-1px);
		position: absolute;
		width: 1px;
	}

	.mark-circle {
		transform: translateX(-2px);
		position: absolute;
		width: 3px;
		height: 3px;
		border-radius: 50%;
	}
	.mark-label {
		transform: translate(9px, -50%);
		position: absolute;
		font-size: 16px;
		line-height: 16px;

		@media (max-width: 480px) {
			font-size: 14px;
			line-height: 14px;
		}
	}
</style>
